import { render, staticRenderFns } from "./myGenejiance.vue?vue&type=template&id=1eebf74a&scoped=true"
import script from "./myGenejiance.vue?vue&type=script&lang=js"
export * from "./myGenejiance.vue?vue&type=script&lang=js"
import style0 from "./myGenejiance.vue?vue&type=style&index=0&id=1eebf74a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebf74a",
  null
  
)

export default component.exports